import React from 'react'
import { Button, Grid, TextField, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'

// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import UserServices from '../../../../Services/Consumers/UserServices'
import { filterData } from '../../../../utils/helpers'
import {
  exportFiltersPayload,
  UserCompaniesFiltersPayload
} from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import DateFilter from './DateFilter'
import moment from 'moment'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'

let { User_Config } = Configuration
export default function PaymentClaimsContent({ handleNotificationCall, locale }) {
  let classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.userPaymentClaimsLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  let NumbersRegex = /^[0-9]+$/
  let isFilterValid = {
    tax_id: true
  }
  const columns = [
    {
      name: 'id',
      label: intl.formatMessage({ id: 'Users.List.Table.ID' }),
      options: {
        display: 'false',
        filter: false,
        viewColumns: false
      }
    },
    {
      name: 'taxpayer_name',
      label: intl.formatMessage({ id: 'CompanyHeader.TaxpayerName' }),
      options: {
        filter: false
      }
    },
    {
      name: 'tax_id',
      label: intl.formatMessage({ id: 'CompanyHeader.UniqueTaxId' }),
      options: {
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='CompanyHeader.UniqueTaxId' />:
                <span>{v}</span>
              </div>
            )
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'CompanyHeader.UniqueTaxId' })}
              id='tax_id'
              name='tax_id'
              value={filterList[index][0] || ''}
              onChange={(event) => {
                filterList[index][0] = event.target.value
                onChange(filterList[index], index, column)
                isFilterValid.tax_id = !(event.target.value && ((event.target.value.length < 9 || event.target.value.length > 10) || !NumbersRegex.test(event.target.value)))
              }}
              helperText={filterList[index][0] &&
                (!NumbersRegex.test(filterList[index][0]) ? intl.formatMessage({ id: 'validationSchema.taxOnlyNumbers' })
                  : (((filterList[index][0]).length < 9 || (filterList[index][0]).length > 10) && intl.formatMessage({ id: 'validationSchema.taxLengthMinMax' })))}
              error={(filterList[index][0] && (!NumbersRegex.test(filterList[index][0]) || ((filterList[index][0]).length < 9 || (filterList[index][0]).length > 10)))}
            />
          )
        }
      }
    },
    {
      name: 'name',
      label: intl.formatMessage({ id: 'CompanyHeader.CompanyName' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'subscription_end_date',
      label: intl.formatMessage({ id: 'CompanyHeader.subscriptionEndDate' }),
      options: {
        display: 'false',
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale='ar-ly' format="Do MMMM YYYY h:mm a">{data[dataIndex].subscription_end_date}</Moment>
        }
      }
    },
    {
      name: 'claim_state',
      label: intl.formatMessage({ id: 'PaymentHeader.claimState' }),
      options: {
        filterOptions: {
          names: ['pending', 'paid'],
          renderValue: (v) => {
            let value = ''
            switch (v) {
              case 'pending':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.pending' })
                break
              case 'paid':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paid' })
                break
              default:
                value = ''
            }
            return value
          }
        },
        customFilterListOptions: {
          render: (v) => {
            let value = ''
            switch (v) {
              case 'pending':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.pending' })
                break
              case 'paid':
                value = intl.formatMessage({ id: 'PaymentHeader.requestState.paid' })
                break
              default:
                value = ''
            }
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.requestState' />:
                <span>{value}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'tax_type',
      label: intl.formatMessage({ id: 'PaymentHeader.climeType' }),
      options: {
        filterOptions: {
          names: [1, 2, 3],
          renderValue: (v) => {
            let value = ''
            switch (v) {
              case 1:
                value = intl.formatMessage({ id: 'PaymentHeader.climeType.income' })
                break
              case 2:
                value = intl.formatMessage({ id: 'PaymentHeader.climeType.vat' })
                break
              case 3:
                value = intl.formatMessage({ id: 'PaymentHeader.climeType.withholding' })
                break
              default:
                value = ''
            }
            return value
          }
        },
        customFilterListOptions: {
          render: (v) => {
            let value = ''
            switch (v) {
              case 1:
                value = intl.formatMessage({ id: 'PaymentHeader.climeType.income' })
                break
              case 2:
                value = intl.formatMessage({ id: 'PaymentHeader.climeType.vat' })
                break
              case 3:
                value = intl.formatMessage({ id: 'PaymentHeader.climeType.withholding' })
                break
              default:
                value = ''
            }
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.climeType' />:
                <span>{value}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'payment_item',
      label: intl.formatMessage({ id: 'PaymentHeader.paymentItem' }),
      options: {
        filterOptions: {
          names: [1, 2, 3, 4, 5, 6, 7, 9, 10, 15, 17, 18, 30, 99],
          renderValue: (v) => {
            let value = ''
            switch (v) {
              case 1:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.adoption_tax' })
                break
              case 2:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.tax_differences_check' })
                break
              case 3:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.compensation' })
                break
              case 4:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.instead_of_confiscations' })
                break
              case 5:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.za' })
                break
              case 6:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.development_fees' })
                break
              case 7:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.reconcile_fees' })
                break
              case 9:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.Fines_and_compensation' })
                break
              case 10:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.instead_of_confiscation' })
                break
              case 15:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.extra_tax' })
                break
              case 17:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.development_fee' })
                break
              case 18:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.reconcile_fee' })
                break
              case 30:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.Bounced_check_allowance' })
                break
              case 99:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.other' })
                break
              default:
                value = ''
            }
            return value
          }
        },
        customFilterListOptions: {
          render: (v) => {
            let value = ''
            switch (v) {
              case 1:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.adoption_tax' })
                break
              case 2:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.tax_differences_check' })
                break
              case 3:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.compensation' })
                break
              case 4:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.instead_of_confiscations' })
                break
              case 5:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.za' })
                break
              case 6:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.development_fees' })
                break
              case 7:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.reconcile_fees' })
                break
              case 9:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.Fines_and_compensation' })
                break
              case 10:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.instead_of_confiscation' })
                break
              case 15:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.extra_tax' })
                break
              case 17:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.development_fee' })
                break
              case 18:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.reconcile_fee' })
                break
              case 30:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.Bounced_check_allowance' })
                break
              case 99:
                value = intl.formatMessage({ id: 'PaymentHeader.paymentItem.other' })
                break
              default:
                value = ''
            }
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='PaymentHeader.paymentItem' />:
                <span>{value}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'claim_amount',
      label: intl.formatMessage({ id: 'PaymentHeader.climeAmount' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <FormattedNumber value={data[dataIndex].claim_amount} />
        }

      }
    },
    {
      name: 'currency',
      label: intl.formatMessage({ id: 'PaymentHeader.currency' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            !!data[dataIndex].currency?.name ?
              <span>
                {data[dataIndex].currency?.name} <strong>({data[dataIndex].currency?.key?.toUpperCase()})</strong>
              </span>
              :
              '—'
          )
        }
      }
    },
    {
      name: 'tax_period_from',
      label: intl.formatMessage({ id: 'PaymentHeader.taxPeriodFrom' }),
      options: {
        filter: true,
        display: 'false',
        filterType: 'custom',
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
            format="Do MMMM YYYY h:mm a">{data[dataIndex].tax_period_from}</Moment>
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='PaymentHeader.taxPeriodFrom' />:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'date'}
              column={column}
              id="tax_period_from"
              label={intl.formatMessage({ id: 'PaymentHeader.taxPeriodFrom' })}
            />
          )
        }
      }
    },
    {
      name: 'tax_period_to',
      label: intl.formatMessage({ id: 'PaymentHeader.taxPeriodTo' }),
      options: {
        filter: true,
        display: 'false',
        filterType: 'custom',
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
            format="Do MMMM YYYY h:mm a">{data[dataIndex].tax_period_to}</Moment>
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='PaymentHeader.taxPeriodTo' />:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'date'}
              column={column}
              id="tax_period_to"
              label={intl.formatMessage({ id: 'PaymentHeader.taxPeriodTo' })}
            />
          )
        }
      }
    },
    {
      name: 'created_at',
      label: intl.formatMessage({ id: 'PaymentHeader.claimCreatedDate' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
            format="Do MMMM YYYY h:mm a">{data[dataIndex].created_at}</Moment>
        }
      }
    },
    {
      name: 'created_from_datetime',
      options: {
        display: 'false',
        viewColumns: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='Fields.placeholder.dateFrom' />:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY, h:mm a">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              column={column}
              type={'datetime-local'}
              id="created_from_datetime"
              label={intl.formatMessage({ id: 'Fields.placeholder.dateFrom' })}
            />
          )
        }
      }
    },
    {
      name: 'created_to_datetime',
      options: {
        display: 'false',
        viewColumns: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='Fields.placeholder.dateTo' />:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY, h:mm a">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'datetime-local'}
              column={column}
              id="created_to_datetime"
              label={intl.formatMessage({ id: 'Fields.placeholder.dateTo' })}
            />
          )
        }
      }
    }
  ]
  // get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {
      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        UserServices.getPaymentClaims({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UserCompaniesFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
          } else {
            if (!!result && !!result.data && !!result.data.data) {
              let newData = []
              result.data.data.forEach((claim) => {
                newData.push({
                  id: claim.id,
                  taxpayer_name: claim.company.taxpayer_name,
                  tax_id: claim.company.tax_id,
                  name: claim.company.name,
                  subscription_end_date: claim.company.subscription_end_date,
                  claim_amount: claim.claim_amount,
                  claim_state: claim.claim_state,
                  tax_type: claim.tax_type,
                  payment_item: claim.payment_item,
                  tax_period_from: claim.tax_period_from,
                  tax_period_to: claim.tax_period_to,
                  created_at: claim.created_at,
                  currency: claim.currency
                })
              })
              setSortOrder(sortOrder)
              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
    getUsersListData(1)
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    console.log(filterList)
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('created_from_datetime' === columns[index].name || 'created_to_datetime' === columns[index].name) {
          filters[columns[index].name] = moment(filterItem[0]).utc().format('DD-MM-YYYY HH:mm:ss')
        } else if ('tax_period_from' === columns[index].name || 'tax_period_to' === columns[index].name) {
          filters[columns[index].name] = moment(filterItem[0]).format('DD-MM-YYYY')
        } else if ('payment_item' === columns[index].name || 'tax_type' === columns[index].name) {
          filters[columns[index].name] = filterItem[0]
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }
  React.useEffect(() => {
    if (!!currentFilter) {
      xhrRequest(1, {}, true)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    onDownload: (buildHead, buildBody, columns, data) => {
      UserServices.exportPaymentClaims({
        headers: {
          'Authorization': `Bearer ${keycloak?.token ?? ''}`,
          'Accept': 'application/octet-stream'
        },
        params: filterData(exportFiltersPayload(currentFilter)),
        responseType: 'blob'
      }).then((result) => {
        if (result.data) {
          const type = result.headers['content-type']
          const blob = new Blob([result.data], { type: type, encoding: 'UTF-8' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = result.headers['content-disposition']
          let fileName = `${intl.formatMessage({ id: 'PaymentsContent.ActionLinks.Payments' })}.xlsx`
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2)
              fileName = fileNameMatch[1]
          }
          link.setAttribute('download', fileName) //or any other extension
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
      return false
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' variant="contained"
            disabled={!(isFilterValid.tax_id)}
            onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters' /></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && typeof type === 'string' && type === 'custom'
          && (column === 'created_from_datetime' || column === 'created_to_datetime' || column === 'tax_id' ||
            column === 'tax_period_from' || column === 'tax_period_to'))) {
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'PaymentRequests.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'PaymentRequests.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <PageTitle title={<FormattedMessage id='PaymentsContent.ActionLinks.Payments' />} />
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true} />}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='PaymentsContent.ActionLinks.Payments' />
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
